import React from "react";
import plur from "plur";
import { Text } from "@jsq/ds/core";
import { stackedMd, stackedLg } from "../../../../common/themes/spacing_styles_vanilla.css";

export type LPSelectAvailablePaymentPrefsHeaderProps = {
  count: number;
};

export const LPSelectAvailablePaymentPrefsHeader: React.FC<
  LPSelectAvailablePaymentPrefsHeaderProps
> = ({ count }: LPSelectAvailablePaymentPrefsHeaderProps) => {
  return (
    <div className={stackedLg}>
      <Text className={stackedMd}>
        Select a payment method to be applied to the {count} selected investment{" "}
        {plur("account", count)}
      </Text>
    </div>
  );
};
